/**
 * {
 *   title: 'Event title',
 *   url: 'https://example.com/event-url',
 *   image: '<img src="…" alt="…">',
 *   dates: '01/01/2022 – 31/12/23',
 *   place: {
 *       title: 'Place title',
 *       map: {
 *           lat: 0.0,
 *           lng: 0.0,
 *           address: '',
 *           placeId: '',
 *       }
 *   }
 * }
 */
const getEventInfoWindowContent = (event) => {
    return `<div class="c-map_infowindow">${renderSingleEvent(event)}</div>`;
};

const getEventsInfoWindowContent = events => {
    let content = "";
    events.forEach(event => {
        content += `<div class="swiper-slide">${renderSingleEvent(event)}</div>`;
    });

    return `
<div class="c-map_infowindow">
    <div class="swiper js-infowindow-swiper">
        <div class="swiper-wrapper">${content}</div>
        <nav>
            <a class="js-infowindow-swiper-prev"><svg aria-hidden="true"><use xlink:href="${m6e.spriteUrl}#icon--arrow"></use></svg> ${i18n.swiperPrev}</a>
            <a class="js-infowindow-swiper-next">${i18n.swiperNext} <svg aria-hidden="true"><use xlink:href="${m6e.spriteUrl}#icon--arrow"></use></svg></a>
        </nav>
    </div>
</div>`;
};

const renderSingleEvent = (event) => {
    let content = "";

    if (event?.image) {
        if (event?.url) {
            content += `<figure class="c-image"><a href="${event.url}">${event.image}</a></figure>`;
        } else {
            content += `<figure class="c-image">${event.image_html}</figure>`;
        }
    }

    if (event?.place?.title) {
        content += `<span>${event.place.title}</span>`;
    }

    if (event?.title) {
        if (event?.url) {
            content += `<h4 class="u-space:m-block u-space:2xs"><a href="${event.url}">${event.title}</a></h4>`;
        } else {
            content += `<h4 class="u-space:m-block u-space:2xs">${event.title}</h4>`;
        }
    }

    content += `<ul class="c-list">`;

    if (event?.dates) {
        content += `<li><svg role="img" focusable="false"><use xlink:href="${m6e.spriteUrl}#icon--calendar"></use></svg>${event.dates}</li>`;
    }

    let address = event?.place?.title && event?.place?.map?.address ? event.place.title + ' ' + event.place.map.address : '';
    let placeId = event?.place?.map?.placeId;

    if (address || placeId) {
        /**
         * @link https://developers.google.com/maps/documentation/urls/get-started
         * @link https://developers.google.com/maps/url-encoding
         */
        let googleMapsLink = new URL('https://www.google.com/maps/search/');
        googleMapsLink.searchParams.set('api', '1');
        googleMapsLink.searchParams.set('query', address);
        googleMapsLink.searchParams.set('query_place_id', placeId);

        content += `<li><svg role="img" focusable="false"><use xlink:href="${m6e.spriteUrl}#icon--map"></use></svg> <a href="${googleMapsLink.toString()}" target="_blank">${i18n.viewOnGoogleMaps}</a></li>`;
    }

    content += `</ul>`;

    return content;
};

export {getEventInfoWindowContent, getEventsInfoWindowContent};
